import axios from 'axios';
import { toast } from 'react-toastify';
export function httpGet(url, config) {
  return axios
    .get(url, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
        toast.error(error.response.data._error.message, { position: toast.POSITION.TOP_CENTER });
      }
      throw error;
    });
}

export function httpPostRaw(url, config) {
  return axios
    .post(url, config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
        toast.error(error.response.data._error.message, { position: toast.POSITION.TOP_CENTER });
      }
      throw error?.response?.data;
    });
}

export function httpPost(url, config) {
  return axios
    .post(url, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
        toast.error(error.response.data._error.message, { position: toast.POSITION.TOP_CENTER });
      } else {
        throw error;
      }
    });
}

export function httpDelete(url, config) {
  return axios.delete(url, config).catch((error) => {
    if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
      toast.error(error.response.data._error.message, { position: toast.POSITION.TOP_CENTER });
    } else {
      throw error;
    }
  });
}
